import {
  influenceListColumnsMap,
} from '@op/pages/Influencer/constants';
import {
  dealwithChannel,
  dealwithCoutry,
  dealwithLanguage,
} from '../../render-helper';
import { specialSecimalFormatPercentage } from '@op/utils/value';

function renderHelperGame(index: number) {
  return (item: any) => {
    const value = item.tweets_games_details || [];
    value.sort((a, b) => b.affinity - a.affinity);
    const info = value?.[index];
    if (!info) return '';
    return `${info.game_name}: ${specialSecimalFormatPercentage(
      info.affinity,
    )}`;
  };
}

export default function influencerColumns(params: any) {
  const { extraParams } = params || {};
  const gameInfo = extraParams?.gameInfo;
  const optionsMap = extraParams?.tagList;
  const commonColumns = [
    { render: 'author_name', header: 'Influencer' },
    {
      render: 'channel_name',
      header: 'Channel',
      renderHelper: [dealwithChannel],
    },
    {
      render: 'language',
      header: 'Language',
      renderHelper: [dealwithLanguage],
    },
    {
      render: 'country',
      header: 'Country',
      renderHelper: [dealwithCoutry],
    },
    { render: 'author_url', header: 'URL' },
    {
      render: 'tags',
      header: 'Segmentation & Tags',
      renderHelper: [
        (item: any, key: string) => {
          const tags = item[key]
            .map((labelKey: string) => {
              const tagName = labelKey.replace('is_', '').replaceAll('_', '-');
              const { downloadText: text } = optionsMap?.[tagName];

              return text || '';
            })
            .join(', ');

          const extraTags = item['ext_tags']
            ?.map((tag) => {
              const { name, tags } = tag;
              const itemInfo = optionsMap?.[name];
              if (!itemInfo) return '';
              const { downloadText: text } = itemInfo;
              const gameList = tags.map((tag: any) => tag.game).join(', ');
              if (gameList) {
                return `${text} (${gameList})`;
              }
              return text || '';
            })
            .join(', ');
          return [tags, extraTags].filter(Boolean).join(', ');
        },
      ],
    },
  ];

  const targetColumns = influenceListColumnsMap(gameInfo).map((item: any) => {
    const curColumn: any = { render: item.key, header: item.header, renderHelper: item?.renderHelper || [] };

    if (item.numFmt) {
      curColumn.numFmt = item.numFmt;
    }

    if (item.showGame) {
      return {
        ...curColumn,
        header: 'Games Covered(Top 3)',
        align: 'center',
        children: [
          {
            render: item.key,
            align: 'center',
            header: 'Top 1',
            renderHelper: [renderHelperGame(0)],
          },
          {
            render: item.key,
            header: 'Top 2',
            align: 'center',
            renderHelper: [renderHelperGame(1)],
          },
          {
            render: item.key,
            align: 'center',
            header: 'Top 3',
            renderHelper: [renderHelperGame(2)],
          },
        ],
      };
    }

    return curColumn;
  });
  return [...commonColumns, ...targetColumns];
}
